// extracted by mini-css-extract-plugin
export default {"discardAlertModal":"Index_discardAlertModal__jUAXa","warningIcon":"Index_warningIcon__SLBko"};